import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosSettings } from "../../axios/axios";
import {
  RegisterApiResponse,
  RegisterParams,
  RegisterState,
} from "./RegisterType";
import { RootState } from "../../redux/store";

export const fetchAsyncRegister: any = createAsyncThunk<
  RegisterApiResponse,
  RegisterParams
>("register/post", async ({ user_id, password, word, name }) => {
  const res = await axiosSettings.post("auth/register.php", {
    user_id,
    password,
    word,
    name,
  });
  return res.data;
});

const initialState: RegisterState = {
  registerSuccess: false,
  msg: "",
};

//slice
export const registerSlice = createSlice({
  name: "register",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAsyncRegister.fulfilled, (state, action) => {
      //登録成功
      if (action.payload.msg === "Success") {
        state.registerSuccess = true;
        state.msg = "";
      }
      //登録失敗
      else {
        state.msg = action.payload.info;
      }
    });
  },
});

export const errorMsg = (state: RootState) => state.register.msg;
export const registerJudge = (state: RootState) =>
  state.register.registerSuccess;

export default registerSlice.reducer;
